import { CustomerName } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/customer'
import { FLAGS_PARAM_NAME } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { LANG_QUERY_PARAM } from '@lyrahealth-inc/shared-app-logic/src/features/intl/constants'

import { oneLine } from '../utils/stringUtils'

export const LYRA_HEALTH_NAME = 'Lyra Health'
export const CSRF_HEADER_NAME = 'CSRF-HEADER_NAME'
export const CSRF_TOKEN = 'CSRF-TOKEN'
export const MATCHER_PREFERENCE = {
  NO_PREFERENCE: { color: 'rgba(73,73,73, 0.3)' },
  ACCEPTABLE: {},
  PREFERRED: { color: '#32CD32' },
}

export const DEFAULT_CUSTOMER = 'defaultCustomer'

export const MEETING_FORMATS = {
  IN_PERSON: 'inPerson',
  VIDEO: 'video',
  PHONE: 'phone',
  LIVE_MESSAGING: 'live_messaging',
}

/* eslint-enable */

export const DISPLAY_LANGUAGE_DISCLOSURE_DISMISSED = 'displayLanguageDisclosureDismissed'
export const DISPLAY_APPOINTMENT_BOOKING_SUCCESS = 'displayNewAppointmentSuccessBanner'

export const careToolProviderSearchFilter = [
  {
    title: 'Gender',
    values: [
      { filterKey: 'genders', filterValue: 'Man', filterName: 'Man' },
      { filterKey: 'genders', filterValue: 'Woman', filterName: 'Woman' },
      { filterKey: 'genders', filterValue: 'Non-binary', filterName: 'Non-binary' },
      { filterKey: 'genders', filterValue: 'Agender', filterName: 'Agender' },
      { filterKey: 'genders', filterValue: 'Gender non-conforming', filterName: 'Gender non-conforming' },
      { filterKey: 'genders', filterValue: 'Genderqueer', filterName: 'Genderqueer' },
      { filterKey: 'genders', filterValue: 'Intersex', filterName: 'Intersex' },
      { filterKey: 'genders', filterValue: 'Two-spirit', filterName: 'Two-spirit' },
      { filterKey: 'genders', filterValue: 'Prefer to self-describe', filterName: 'Prefer to self-describe' },
      { filterKey: 'genders', filterValue: 'Prefer not to state', filterName: 'Prefer not to state' },
    ],
  },
  {
    title: 'Credentials',
    values: [
      { filterKey: 'credentials', filterValue: 'LCSW', filterName: 'LCSW' },
      { filterKey: 'credentials', filterValue: 'LMFT', filterName: 'LMFT' },
      { filterKey: 'credentials', filterValue: 'PhD', filterName: 'PhD' },
      { filterKey: 'credentials', filterValue: 'PsyD', filterName: 'PsyD' },
    ],
  },
  {
    title: 'Provider Type',
    values: [
      { filterKey: 'lyraType', filterValue: 'LyraPrescriber', filterName: 'LC Prescriber' },
      { filterKey: 'lyraType', filterValue: 'LyraTherapist', filterName: 'LC Therapist' },
      {
        filterKey: 'mosApproved',
        filterValue: 'true',
        filterName: 'Leidos/MOS Approved Lyra Providers',
        applicableCustomers: [CustomerName.LEIDOS],
      },
      {
        filterKey: 'isDirectAccess',
        filterValue: 'true',
        filterName: 'DA',
        applicableCustomers: [CustomerName.UPHS],
      },
    ],
  },
  {
    title: 'Suicidality',
    values: [
      { filterKey: 'activeSuicidality', filterValue: 'true', filterName: 'SI Positive' },
      { filterKey: 'neutralSuicidality', filterValue: 'true', filterName: 'SI Neutral' },
    ],
  },
  {
    title: 'Conditions',
    values: [
      { filterKey: 'conditions', filterValue: 'Gender Dysphoria', filterName: 'Gender Dysphoria' },
      { filterKey: 'conditions', filterValue: 'Self-Harm', filterName: 'Self-Harm' },
      { filterKey: 'conditions', filterValue: 'Sexual Orientation', filterName: 'Sexual Orientation' },
      { filterKey: 'conditions', filterValue: 'Alcohol Use', filterName: 'Alcohol Use' },
      { filterKey: 'conditions', filterValue: 'Drug Use', filterName: 'Drug Use' },
      { filterKey: 'conditions', filterValue: 'Cannabis Use', filterName: 'Cannabis Use' },
      { filterKey: 'conditions', filterValue: 'Trauma and PTSD', filterName: 'Trauma and PTSD' },
    ],
  },
  {
    title: 'Ethnicities',
    values: [
      { filterKey: 'providerEthnicity', filterValue: 'White', filterName: 'White' },
      {
        filterKey: 'providerEthnicity',
        filterValue: 'Black or African American',
        filterName: 'Black or African American',
      },
      { filterKey: 'providerEthnicity', filterValue: 'Asian', filterName: 'Asian' },
      { filterKey: 'providerEthnicity', filterValue: 'Hispanic or Latino', filterName: 'Hispanic or Latino' },
      { filterKey: 'providerEthnicity', filterValue: 'Native American', filterName: 'Native American' },
      {
        filterKey: 'providerEthnicity',
        filterValue: 'Native Hawaiian or Pacific Islander',
        filterName: 'Native Hawaiian or Pacific Islander',
      },
      { filterKey: 'providerEthnicity', filterValue: 'Two or More', filterName: 'Two or More' },
      { filterKey: 'providerEthnicity', filterValue: 'Other', filterName: 'Other' },
      {
        filterKey: 'providerEthnicity',
        filterValue: 'Prefer to self-describe',
        filterName: 'Prefer to self-describe',
      },
      { filterKey: 'providerEthnicity', filterValue: 'Prefer not to state', filterName: 'Prefer not to state' },
    ],
  },
  {
    title: 'Experience',
    values: [
      { filterKey: 'yearsOfExperience', filterValue: '< 5 years', filterName: '< 5 years' },
      { filterKey: 'yearsOfExperience', filterValue: '5-10 years', filterName: '5-10 years' },
      { filterKey: 'yearsOfExperience', filterValue: '10-15 years', filterName: '10-15 years' },
      { filterKey: 'yearsOfExperience', filterValue: '15-20 years', filterName: '15-20 years' },
      { filterKey: 'yearsOfExperience', filterValue: '> 20 years', filterName: '> 20 years' },
    ],
  },
  {
    title: 'Video',
    values: [
      { filterKey: 'videoIndividual', filterValue: 'true', filterName: 'Individual' },
      { filterKey: 'videoChild', filterValue: 'true', filterName: 'Child' },
      { filterKey: 'videoCouples', filterValue: 'true', filterName: 'Couples' },
    ],
  },
  { title: 'Calendar', values: [{ filterKey: 'isCalendarConnected', filterValue: 'true', filterName: 'Connected' }] },
  {
    title: 'Languages',
    values: [
      { filterKey: 'languages', filterValue: 'Chinese', filterName: 'Chinese' },
      { filterKey: 'languages', filterValue: 'Russian', filterName: 'Russian' },
      { filterKey: 'languages', filterValue: 'Spanish', filterName: 'Spanish' },
    ],
  },
  {
    title: 'Treatments',
    values: [
      { filterKey: 'treatments', filterValue: 'ACT', filterName: 'ACT' },
      { filterKey: 'treatments', filterValue: 'Behavior Modification', filterName: 'Behavior Modification' },
      { filterKey: 'treatments', filterValue: 'CBT-I', filterName: 'CBT-I' },
      { filterKey: 'treatments', filterValue: 'CPT', filterName: 'CPT' },
      { filterKey: 'treatments', filterValue: 'DBT', filterName: 'DBT' },
      { filterKey: 'treatments', filterValue: 'EFT', filterName: 'EFT' },
      { filterKey: 'treatments', filterValue: 'EMDR', filterName: 'EMDR' },
      { filterKey: 'treatments', filterValue: 'ERP', filterName: 'ERP' },
      { filterKey: 'treatments', filterValue: 'Gottman', filterName: 'Gottman' },
      { filterKey: 'treatments', filterValue: 'MBCT', filterName: 'MBCT' },
      { filterKey: 'treatments', filterValue: 'Prolonged Exposure', filterName: 'Prolonged Exposure' },
    ],
  },
  {
    title: 'Racial Stress',
    values: [{ filterKey: 'racialStressPreferred', filterValue: 'true', filterName: 'Specializes in racial stress' }],
  },
  {
    title: 'Provider Transgender',
    values: [{ filterKey: 'providerTransgender', filterValue: 'true', filterName: 'Provider Transgender' }],
  },
  {
    title: 'Provider Sexual Orientation',
    values: [
      { filterKey: 'providerSexualOrientation', filterValue: 'Asexual', filterName: 'Asexual' },
      { filterKey: 'providerSexualOrientation', filterValue: 'Bisexual/Pansexual', filterName: 'Bisexual/Pansexual' },
      { filterKey: 'providerSexualOrientation', filterValue: 'Lesbian', filterName: 'Lesbian' },
      { filterKey: 'providerSexualOrientation', filterValue: 'Gay', filterName: 'Gay' },
      {
        filterKey: 'providerSexualOrientation',
        filterValue: 'Heterosexual/Straight',
        filterName: 'Heterosexual/Straight',
      },
      {
        filterKey: 'providerSexualOrientation',
        filterValue: 'Prefer to self-describe',
        filterName: 'Prefer to self-describe',
      },
      { filterKey: 'providerSexualOrientation', filterValue: 'Prefer not to state', filterName: 'Prefer not to state' },
      {
        filterKey: 'providerSexualOrientation',
        filterValue: 'Does not apply',
        filterName: 'Does not apply',
      },
    ],
  },
  {
    title: 'Religions',
    values: [
      { filterKey: 'religions', filterValue: 'Christian', filterName: 'Christian' },
      { filterKey: 'religions', filterValue: 'Jewish', filterName: 'Jewish' },
      { filterKey: 'religions', filterValue: 'Hindu', filterName: 'Hindu' },
      {
        filterKey: 'religions',
        filterValue: 'Mormon (Church of Jesus Christ/LDS)',
        filterName: 'Mormon (Church of Jesus Christ/LDS)',
      },
      { filterKey: 'religions', filterValue: 'Buddhist', filterName: 'Buddhist' },
      { filterKey: 'religions', filterValue: 'Muslim', filterName: 'Muslim' },
      {
        filterKey: 'religions',
        filterValue: 'Non-religious/atheist/agnostic',
        filterName: 'Non-religious/atheist/agnostic',
      },
    ],
  },
]

export const PAYMENT_CARD_TYPES = {
  CREDIT_DEBIT: 'credit_debit',
  FSA_HSA: 'fsa_hsa',
  PREPAID: 'prepaid',
  UNKNOWN: 'unknown',
  OTHER: 'other',
}

export const PAYMENT_CARD_TYPES_DISPLAY = {
  [PAYMENT_CARD_TYPES.CREDIT_DEBIT]: 'Credit/Debit',
  [PAYMENT_CARD_TYPES.FSA_HSA]: 'FSA/HSA',
  [PAYMENT_CARD_TYPES.PREPAID]: 'Prepaid',
  [PAYMENT_CARD_TYPES.OTHER]: 'Other',
  [PAYMENT_CARD_TYPES.UNKNOWN]: 'Unknown',
}

/**
 * Default services that Lyra does not cover.
 * You should only be importing this if you need this list in a custom string, e.g. a custom "servicesNotCovered" string
 * that doesn't match the content of the servicesNotCovered string here. Otherwise, you probably want to be importing
 * servicesNotCovered instead.
 * If your customer has a custom "servicesNotCovered" string and doesn't cover meds, check defaultWithoutMeds.js
 */
export const excludedServices = oneLine(
  `inpatient or residential treatment, hospitalization (including partial),
  intensive outpatient treatment, emergent care, long-term care or counseling, prescription medication,
  autism spectrum disorder treatment, services for remedial education, executive coaching, and non-evidence-based behavioral health care`,
)

export const APP_ID = 'Lyraweb'
export const APP_PLATFORM = 'web'

export const VENDOR_API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://vendorapi.lyrahealth.com'
    : 'https://vendorapi.staging.lyrahealth.com'

export const mixpanelReplaysPercent = process.env.NODE_ENV === 'production' ? 100 : 0

export const INTERNATIONAL_CONSENT_USER_STATUS = {
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  NONE: 'None',
}

export const POINT_OF_REQUEST = {
  DIRECT_LINK: 'direct_link',
  TRIAGE: 'triage',
}

export const clientSessionContainerId = 'clientSession'

// iframe post messages
export const SEND_SIGN_UP_BUTTON_WIDTH_MESSAGE = 'LW_SEND_SIGN_UP_BUTTON_WIDTH_MESSAGE'
export const GET_GOOGLE_SIGN_UP_BUTTON_WIDTH_MESSAGE = 'LW_GET_GOOGLE_SIGN_UP_BUTTON_WIDTH_MESSAGE'
export const GET_APPLE_SIGN_UP_ERROR = 'LW_GET_APPLE_SIGN_UP_ERROR'
export const GET_APPLE_SIGN_UP_TOKEN = 'LW_GET_APPLE_SIGN_UP_TOKEN'
export const GET_GOOGLE_SIGN_UP_TOKEN = 'LW_GET_GOOGLE_SIGN_UP_TOKEN'
export const CLICK_SSO_SIGN_UP_BUTTON = 'LW_CLICK_SSO_SIGN_UP_BUTTON'
// Sent by an SSO iframe once its button has actually painted (after mount + a paint frame), so the
// parent can gate the reveal on the button being visible rather than on the iframe's document load.
export const SSO_SIGN_UP_BUTTON_RENDERED = 'LW_SSO_SIGN_UP_BUTTON_RENDERED'

/**
 * List of global query params that should be preserved in the URL across route changes
 */
export const STICKY_QUERY_PARAMS = [
  LANG_QUERY_PARAM, // Override the app language
  FLAGS_PARAM_NAME, // Override feature flags (via useFlags)
  'utm_source', // UTM tracking parameter
  'utm_medium', // UTM tracking parameter
  'utm_campaign', // UTM tracking parameter
  'utm_content', // UTM tracking parameter
  'utm_date', // UTM tracking parameter
] as const

export const ATTESTATION_VERIFICATION = 'attestationVerification'
export const MOBILE_PROMO_DISMISSED = 'mobilePromoDismissed'

export const INACTIVITY_CHECK_INTERVAL_MS = 500
export const USER_ACTIVITY_THROTTLE_MS = 30 * 1000

export const ERROR_CODES = {
  UNPROCESSABLE_ENTITY: 422,
}

export const COST_SHARE_TERMS_LINK = 'https://www.lyrahealth.com/cost-share-terms-conditions/'
// TODO: Update to production URL when available. Currently using staging URL for self-pay MVP.
export const SELF_PAY_TERMS_LINK = 'https://lyrastage.wpengine.com/lyra-self-pay-terms-conditions/'
export const LYRA_MARKETING_LAUNCH_DAY_REMINDER_LINK = 'https://cloud.mc.lyrahealth.com/launch_date_reminder_signup'

// Registry of messages sent by Bukwild to LW using window.postMessage
export enum ESSENTIALS_IFRAME_MESSAGES {
  USER_REACHED_CONTENT_THRESHOLD = 'USER_REACHED_CONTENT_THRESHOLD', // example: {event: 'USER_REACHED_CONTENT_THRESHOLD', contentId: '12345', contentKind: 'ARTICLE', completionPercent: 60, contentViewId: '67890'}
  MODAL_CLOSED = 'modalClosed', // example: {event: 'modalClosed', modalName: 'ORIENTATION_MIXES', uri: '/secure/essentials/'}
  MODAL_OPENED = 'modalOpened', // example:{event: 'modalOpened', modalName: 'ORIENTATION_MIXES', uri: '/secure/essentials/'}
  ROUTE_CHANGE = 'routeChange', // example: {event: 'routeChange', navigation: {backButtonHidden: false, xButtonHidden: true}, uri: '/mixes?mixIndex=0'}
  NAVIGATE_TO_PARENT_APP_ROUTE = 'navigateToParentAppRoute',
  NAVIGATE_TO_FIND_PROVIDER = 'navigate to find provider',
  NAVIGATE_TO_SEARCH_FOR_CARE = 'navigate to search for care',
  CONTENT_PLAYING = 'content playing', // sent in 20s intervals while Essentials media is playing to prevent inactive log out
  CREATE_COURSE_COMPLETION_CERTIFICATE = 'create course completion certificate', // example: { event: "create course completion certificate", courseName: "Tackling Mental Health Stigma", courseCompletionDate: Date object }
  CREATE_COURSE_COMPLETION_CERTIFICATE_URL = 'create course completion certificate URL',
  COURSE_COMPLETION_CERTIFICATE_URL_CREATED = 'course completion certificate URL created',
  REGISTER_FOR_EVENT = 'registerForEvent', // example: {event: 'registerForEvent', zoom_event_id: '12345', zoom_event_type: 'MEETING', event_category: 'MEDITATION' (optional)}
  DEREGISTER_FOR_EVENT = 'deregisterForEvent', // example: {event: 'deregisterForEvent', zoom_event_id: '12345', zoom_event_type: 'MEETING', registrant_id: '12928139218', event_category: 'MEDITATION' (optional)}
  EVENT_REGISTERED_COUNT = 'registeredCount', // example: {event: 'registeredCount', events: [{zoom_event_id: '12345', zoom_event_type: 'MEETING'}]}
  NAVIGATE_BETWEEN_LIBRARY_APPS = 'navigate between library apps', // {event: 'navigate between library apps', url: <workhub or essentials url>}
  NAVIGATE_TO_COACHING_DIRECT_PATH = 'direct path to coaching', // example: { event: 'direct path to coaching', coachingUrl: https://lyra.app.link/directPathBooking?directPath=true&clientele=Individual&treatment=Coaching&partner=BlendedCare&offering=Default&directLinkIntent=DIRECT_LINK_WORKPLACE&$fallback_url=https://{customer.lyrahealth.com}/secure/onboard/match-location }
  /** Send mixpanel properties under `props` to Goodness to be sent from events fired by Goodness */
  SET_MIXPANEL_PROPS = 'setMixpanelProps',
  /** Remove specific properties from mixpanel by sending the prop keys under `props` */
  UNSET_MIXPANEL_PROPS = 'unsetMixpanelProps',
  /** Removes all super props set in mixpanel */
  RESET_MIXPANEL_PROPS = 'resetMixpanelProps',
  /** Essentials iframe is ready. Should be more reliable than iFrame onLoad */
  IFRAME_APP_READY = 'iframeAppReady',
  NAVIGATE_TO_LOGIN = 'navigateToLogin',
  NAVIGATE_TO_REGISTER = 'navigateToRegister',
}

export enum ESSENTIALS_MODAL {
  MIXES_PLAYER = 'MIXES_PLAYER',
  SEARCH_FOR_CARE = 'SEARCH_FOR_CARE',
  ORIENTATION_MIXES = 'ORIENTATION_MIXES',
}

export enum LOCAL_STORAGE_KEY {
  TOOLKIT_ESSENTIALS_CONTENTS = 'toolkitEssentialsContents',
  ANIMATE_MENU_BADGE = 'animateMenuBadge',
  IS_USER_GOOGLE_CRITICAL_TALENT = 'is_user_google_critical_talent',
  CACHED_ESSENTIALS_CONTENTS = 'cachedEssentialsContents',
  ESSENTIALS_EVENT_SLUG = 'essentialsEventSlug',
  CARE_OPTIONS_SEARCHER_TYPE = 'careOptionsSearcherType',
  // Manager coaching microsite banner keys
  HAS_VISITED_MANAGER_COACHING_MICROSITE = 'hasVisitedManagerCoachingMicrosite',
  HAS_DISMISSED_MANAGER_COACHING_BANNER = 'hasDismissedManagerCoachingBanner',
  HAS_NAVIGATED_TO_MANAGER_COACHING_PROVIDER_BOOKING = 'hasNavigatedToManagerCoachingProviderBooking',
  // Google Performance (Catalyst) microsite banner keys
  HAS_VISITED_GOOGLE_PERFORMANCE_MICROSITE = 'hasVisitedGooglePerformanceMicrosite',
  HAS_DISMISSED_GOOGLE_PERFORMANCE_BANNER = 'hasDismissedGooglePerformanceBanner',
  HAS_NAVIGATED_TO_GOOGLE_PERFORMANCE_PROVIDER_BOOKING = 'hasNavigatedToGooglePerformanceProviderBooking',
}

export const IS_SESSION_TIMER_DISABLED = 'isSessionTimerDisabled'
export const CYPRESS_CARE_REFERENCE_ID = 'cypress-care-reference-id'

export const PARTNER_SSO_REGISTRATION_DATA_COOKIE = 'partnerSsoRegistrationData'
export const CONNECTED_SERVICE_DATA_COOKIE = 'connectedServiceRegistrationLoginData'

export enum CONNECTED_SERVICE_ATTESTATION_QUERY_PARAMS {
  CONNECTED_SERVICE = 'connectedService',
}

export enum VERIFY_ATTESTATION_QUERY_PARAMS {
  TOKEN = 'token',
  ID = 'id',
  SHOW_ELIGIBILITY = 'showEligibility',
  REDIRECT = 'redirect',
  IS_SSO = 'isSSO',
}
